<template>
  <div class="row">
    <div class="col-sm-12">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th v-for="column in sortable.columns" :key="column.name"
              @click="column.sortable ? $emit('sortBy', column.key) : false"
              class="sortable" :class="sortable.sortColumn === column.key ? 'active-sort' : ''"
              :style="column.sortable ? 'padding-right: 12px;' : ''"
              :width="column.width || 'auto'"
              v-tooltip.top-center="column.tooltip || false"
              v-show="column.name !== 'Lager' || showWarehouses"
            >
              <span :style="column.sortable ? 'padding-right: 2px;' : ''">{{ column.name }}</span>
              <i class="fas" style="position: absolute; padding-left: 2px;"
                v-if="column.sortable"
                :class="sortable.sortOrders[column.key] > 0 ? 'fa-sort-up' : 'fa-sort-down'"
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in products" :key="product.id"
            :only-show-action="onlyShowAction"
            is="ProductRow"
            :product="product"
            @openSuppliers="openSuppliers"
            @deleteProduct="$emit('deleteProduct', $event)"
            @openWarehouses="openWarehouses"
            @filterProductCategory="$emit('filterProductCategory', $event)"
            :show-warehouses="showWarehouses"
            @enterEditMode="enterEditMode"
            @exitEditMode="exitEditMode"
            @saveEdit="saveEdit"
            :edit-mode="product.id === editMode"
            :product-categories="productCategories"
            :units="units"
            @openAssignToSuppliersDialog="openAssignToSuppliersDialog"
            @openStockRotationModal="openStockRotationModal"
          />
        </tbody>
      </table>
    </div>
    <product-suppliers-dialog
      :show="showSuppliersDialog"
      :product="selectedProduct"
      @deleteProductSupplier="deleteProductSupplier"
      @close="showSuppliersDialog = false"
    />
    <product-warehouses-dialog
      :show="showWarehousesDialog"
      :product-warehouses="productWarehouses"
      @close="showWarehousesDialog = false"
    />
    <assign-to-supplier-dialog v-if="productToAssign"
      :show="showAssignToSuppliersDialog"
      :suppliers="suppliers"
      @assignToSupplier="assignToSupplier"
      @close="closeAssignToSuppliersDialog"
      :val-errors="assignErrors"
      :init-price="productToAssign.standard_price || ''"
      :init-referenznummer="productToAssign.referenznummer || ''"
    />
    <create-stock-rotations-dialog
      :show="showCreateStockRotationsDialog"
      :product="productToCreateStockRotatios"
      :causes="causesForStockRotation"
      @close="closeCreateStockRotationsDialog"
    />
  </div>
</template>

<script>
import ProductSuppliersDialog from './product-suppliers-dialog'
import ProductWarehousesDialog from './product-warehouses-dialog'
import ProductRow from './product-row'
import AssignToSupplierDialog from './assign-to-supplier-dialog'
import CreateStockRotationsDialog from './create-stock-rotations-dialog'

export default {
  props: {
    products: Array,
    loading: {
      default: false
    },
    onlyShowAction: {
      default: false
    },
    showWarehouses: {
      default: true
    },
    productCategories: Array,
    sortable: Object
  },
  components: {
    ProductSuppliersDialog,
    ProductWarehousesDialog,
    ProductRow,
    AssignToSupplierDialog,
    CreateStockRotationsDialog
  },
  data () {
    return {
      productSuppliers: [],
      productWarehouses: [],
      showSuppliersDialog: false,
      showWarehousesDialog: false,
      selectedProduct: null,
      editMode: null,
      units: [],
      suppliers: [],
      showAssignToSuppliersDialog: false,
      productToAssign: null,
      assignErrors: [],
      productToCreateStockRotatios: null,
      showCreateStockRotationsDialog: false,
      causesForStockRotation: []
    }
  },
  methods: {
    openSuppliers ({ productSuppliers, product }) {
      this.selectedProduct = product
      this.showSuppliersDialog = true
    },
    openWarehouses (product) {
      this.$http.get(`/products/${product.id}/warehouses`).then(({ data }) => {
        this.productWarehouses = data
        this.showWarehousesDialog = true
      })
    },
    async deleteProductSupplier (supplier) {
      if (confirm('Zuweisung zum Lieferanten wirklich löschen?')) {
        await this.initCsrf()

        this.$http.delete(`/product_supplier/${supplier.id}`).then(({ data }) => {
          const index = this.selectedProduct.suppliers.findIndex(({ id }) => id === data.id)
          this.selectedProduct.suppliers.splice(index, 1)
        })
      }
    },
    enterEditMode (product) {
      this.editMode = product.id
    },
    exitEditMode (product) {
      this.editMode = null
    },
    saveEdit (product) {
      this.$emit('updateProduct', product)
      this.editMode = null
    },
    openAssignToSuppliersDialog (product) {
      this.productToAssign = product
      let loadSuppliers = Promise.resolve()
      if (!this.suppliers.length) {
        loadSuppliers = this.$http.get(`/suppliers`).then(({ data }) => {
          this.suppliers = data
        })
      }
      loadSuppliers.then(() => { this.showAssignToSuppliersDialog = true })
    },
    async assignToSupplier (payload) {
      await this.initCsrf()

      const url = `/products/${this.productToAssign.id}/suppliers/${payload.supplier_id}`
      this.$http.post(url, { price: payload.price, referenznummer: payload.referenznummer }).then(({ data }) => {
        this.$notify({
          message: 'Produkt erfolgreich dem Lieferanten zugewiesen.',
          type: 'success'
        })
        this.productToAssign.suppliers.unshift(data)
        this.closeAssignToSuppliersDialog()
        // this.productSuppliersFetched.unshift(data)
      }).catch(({ response }) => { this.assignErrors = response.data.errors })
    },
    closeAssignToSuppliersDialog () {
      this.showAssignToSuppliersDialog = false
      this.productToAssign = null
    },
    openStockRotationModal ({ direction, product }) {
      this.showCreateStockRotationsDialog = true
      this.$http.get(`/causes?only_selectable=1&direction=${direction}`).then(({ data }) => {
        this.causesForStockRotation = data
        this.productToCreateStockRotatios = product
      })
    },
    closeCreateStockRotationsDialog () {
      this.showCreateStockRotationsDialog = false
      this.productToCreateStockRotatios = null
      this.causesForStockRotation = []
    }
  },
  created () {
    this.$http.get(`/units`).then(({ data }) => { this.units = data })
  }
}
</script>

<style scoped>
.sortable {
  cursor: pointer;
}

.active-sort {
  font-weight: bold;
}
</style>
